import { runFetch } from "../../index"

export const utilityApi = (origin, token) => {
  return {
    isAvailable: async () => {
      try {
        const result = await runFetch(
          `/resources/${encodeURIComponent("dummyApplication")}`,
          token,
          origin
        )
        return !!result
      } catch (e) {
        return false
      }
    },
    hasAdminAccess: async () => {
      try {
        const appName = "entitlex-adminportal"
        const resourceName = "entitlex-users"
        const result = await runFetch(
          `/resources/${encodeURIComponent(appName)}/check?resourceName=${resourceName}`,
          token,
          origin
        )
        return result.hasAccess === true
      } catch (e) {
        return false
      }
    }
  }
}
